
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"vector-effect":"non-scaling-stroke","d":"M-1 0h32v32H-1z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M11.698 24.26h11.476V7.74H11.596a.75.75 0 110-1.5h12.328a.75.75 0 01.75.75v18.02a.75.75 0 01-.75.75H11.698a.75.75 0 010-1.5z","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"d":"M10.537 12.462a.744.744 0 01-.22.53l-2.046 2.046h11.024a.75.75 0 010 1.5H8.315l1.996 1.996a.75.75 0 11-1.06 1.061l-3.276-3.277c-.005-.004-.007-.01-.01-.014l-.013-.008c-.023-.022-.032-.053-.052-.078-.023-.032-.048-.063-.065-.098a.742.742 0 01.117-.885l3.305-3.303a.749.749 0 011.28.53","vector-effect":"non-scaling-stroke"}})])])])])
          )
        }
      }
    